<style scoped="scoped" lang="scss"></style>
<style>
/* 重写全局 hiprint 样式 */
.hiprint-headerLine,
.hiprint-footerLine {
  border-color: #1890ff !important;
}

.hiprint-headerLine:hover,
.hiprint-footerLine:hover {
  border-top: 3px dashed #1890ff !important;
}

.hiprint-headerLine:hover:before {
  content: '页眉线';
  left: calc(50% - 18px);
  position: relative;
  background: #ffff;
  top: -14px;
  color: #1890ff;
  font-size: 12px;
}

.hiprint-footerLine:hover:before {
  content: '页脚线';
  left: calc(50% - 18px);
  position: relative;
  color: #1890ff;
  background: #ffff;
  top: -14px;
  font-size: 12px;
}
</style>
<style scoped>
/* 区域 */
.left {
  background: white;
  border: 1px solid #d9d9d9;
  padding: 10px;
  overflow: auto;
  box-sizing: border-box;
}

.center {
  margin: 0 10px;
  background: white;
  border: 1px solid #d9d9d9;
  padding: 14px;
  overflow: auto;
}

.right {
  background: white;
  border: 1px solid #d9d9d9;
  padding: 10px;
  overflow: auto;
}

/* 左侧拖拽元素样式 */
.title {
  font-size: 16px;
  font-weight: 500;
  width: 100%;
  margin: 10px 0 0 24px;
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  width: 80px;
  min-height: 60px;
}

.item {
  padding: 10px;
  text-align: center;
}

.item img {
  width: 28px;
  height: auto;
}

.item span {
  color: #1890ff;
  font-size: 14px;
  font-weight: bold;
  margin-top: 4px;
}
</style>
<template>
  <div style="width: 100%;height: 100%;overflow: auto;">
    <div style="margin-top: 10px ;width: 100%;display: flex;align-items: center;justify-content: space-between;padding: 0 10px;">
      <!-- <button @click.stop="print">
        浏览器打印
      </button>
      <button @click.stop="print2">
        直接打印(需要连接客户端)
      </button> -->
      <div>
        <!-- <a-popover v-model="paperPopVisible" title="设置纸张宽高(mm)" trigger="click">
            <div slot="content">
              <a-input-group compact style="margin: 10px 10px">
                <a-input type="number" v-model="paperWidth" style=" width: 100px; text-align: center"
                         placeholder="宽(mm)"/>
                <a-input style=" width: 30px; border-left: 0; pointer-events: none; backgroundColor: #fff"
                         placeholder="~" disabled
                />
                <a-input type="number" v-model="paperHeight" style="width: 100px; text-align: center; border-left: 0"
                         placeholder="高(mm)"/>
              </a-input-group>
              <a-button type="primary" style="width: 100%" @click="otherPaper">确定</a-button>
            </div>
            <a-button :type="'other'==curPaperType?'primary':''">自定义纸张</a-button>
          </a-popover> -->
        <!-- </a-button-group>
        <a-button type="text" icon="zoom-out" @click="changeScale(false)"></a-button>
        <a-input-number
          :value="scaleValue"
          :min="scaleMin"
          :max="scaleMax"
          :step="0.1"
          disabled
          style="width: 70px;"
          :formatter="value => `${(value * 100).toFixed(0)}%`"
          :parser="value => value.replace('%', '')"
        />
        <a-button type="text" icon="zoom-in" @click="changeScale(true)"></a-button> -->
      </div>
      <div style="display: flex;">
        <div style="margin-right:20px">
          <el-button-group>
            <el-button size="mini" @click="setPaper(type, value)" v-for="(value, type) in paperTypes" :type="type == curPaperType ? 'primary' : ''" :key="type">{{ type }}</el-button>

            <el-popover v-model="paperPopVisible" title="设置纸张宽高(mm)" trigger="click">
              <div style="display:flex;justify-content:space-between;align-items:center">
                <el-input size="mini" type="number" v-model="paperWidth" style=" width: 80px; text-align: center" placeholder="宽(mm)" />
                <p style="margin:0 4px">x</p>
                <el-input size="mini" type="number" v-model="paperHeight" style="width: 80px; text-align: center; border-left: 0" placeholder="高(mm)" />
              </div>
              <el-button size="mini" type="primary" style="width: 100%;margin-top:10px" @click="otherPaper">确定</el-button>

              <el-button size="mini" slot="reference" :type="'other' == curPaperType ? 'primary' : ''">自定义纸张</el-button>
            </el-popover>
          </el-button-group>
        </div>
        <div style="margin-right:20px">
          <el-button size="mini" type="text" icon="el-icon-zoom-out" @click="changeScale(false)"></el-button>
          <el-input-number size="mini" :value="scaleValue" :min="scaleMin" :controls="false" :max="scaleMax" :precision="1" :step="0.1" disabled style="width: 70px;" />
          <el-button size="mini" type="text" icon="el-icon-zoom-in" @click="changeScale(true)"></el-button>
        </div>
        <div>
          <img src="./img/12.png" @click="setElsAlign('left')" style="width: 20px;height:auto;cursor: pointer;margin-right: 8px;" lt="左对齐" />
          <img src="./img/13.png" @click="setElsAlign('vertical')" style="width: 20px;height:auto;cursor: pointer;margin-right: 8px;" lt="居中" />
          <img src="./img/14.png" @click="setElsAlign('right')" style="width: 20px;height:auto;cursor: pointer;margin-right: 8px;" lt="右对齐" />
          <img src="./img/15.png" @click="setElsAlign('top')" style="width: 20px;height:auto;cursor: pointer;margin-right: 8px;" lt="顶部对齐" />
          <img src="./img/16.png" @click="setElsAlign('horizontal')" style="width: 20px;height:auto;cursor: pointer;margin-right: 8px;" lt="垂直居中" />
          <img src="./img/17.png" @click="setElsAlign('bottom')" style="width: 20px;height:auto;cursor: pointer;margin-right: 8px;" lt="底部对齐" />
          <img src="./img/18.png" @click="setElsAlign('distributeHor')" style="width: 20px;height:auto;cursor: pointer;margin-right: 8px;" lt="横向分散" />
          <img src="./img/19.png" @click="setElsAlign('distributeVer')" style="width: 10px;height:auto;cursor: pointer;margin-right: 8px;" lt="纵向分散" />
        </div>
      </div>
      <div style="display: flex;;">
        <el-button style="margin-right: 0px;" size="mini" type="primary" @click="exportPdf('pdfobjectnewwindow')">预览 </el-button>
        <el-button v-if="false" size="mini" type="primary" @click="save()">
          保存
        </el-button>
      </div>

      <!-- <button type="primary" @click="exportPdf('')">
        打印
      </button> -->
    </div>
    <div style="height:100%;display: flex;justify-content: space-between;padding: 10px;">
      <div class="left" style="flex: 2;">
        <div style="display: flex;flex-flow: wrap;">
          <div class="title" style="font-weight: bold;">基础元素</div>
          <div class="ep-draggable-item item" tid="defaultModule.text">
            <img src="./img/8.png" />
            <span>文本</span>
          </div>
          <div class="ep-draggable-item item" tid="defaultModule.image">
            <img src="./img/7.png" />
            <span>图片</span>
          </div>
          <div class="ep-draggable-item item" tid="defaultModule.longText">
            <img src="./img/6.png" />
            <span>长文</span>
          </div>
          <div class="ep-draggable-item item" tid="defaultModule.table">
            <img src="./img/2.png" />
            <span>表格</span>
          </div>
          <div class="ep-draggable-item item" tid="defaultModule.html">
            <img src="./img/1.png" />
            <span>html</span>
          </div>
          <div class="ep-draggable-item item" tid="defaultModule.customText">
            <img src="./img/1.png" />
            <span>自定义</span>
          </div>
          <div class="title" style="font-weight: bold;">辅助元素</div>
          <div class="ep-draggable-item item" tid="defaultModule.hline">
            <img src="./img/9.png" style="width:auto;height: 14px;" />
            <span style="margin-top: 18px;">横线</span>
          </div>
          <div class="ep-draggable-item item" tid="defaultModule.vline">
            <img src="./img/10.png" style="width: 13px;" />
            <span>竖线</span>
          </div>
          <div class="ep-draggable-item item" tid="defaultModule.rect">
            <img src="./img/11.png" />
            <span>矩形</span>
          </div>
          <div class="ep-draggable-item item" tid="defaultModule.oval">
            <img src="./img/3.png" />
            <span>圆形</span>
          </div>
          <div class="ep-draggable-item item" tid="defaultModule.barcode">
            <img src="./img/4.png" />
            <span>条形码</span>
          </div>
          <div class="ep-draggable-item item" tid="defaultModule.qrcode">
            <img src="./img/5.png" />
            <span>二维码</span>
          </div>
        </div>
      </div>
      <div class="center" style="flex: 5;">
        <!-- 设计器的 容器 -->
        <div id="hiprint-printTemplate"></div>
      </div>
      <div class="right" style="flex: 2;">
        <!-- 元素参数的 容器 -->
        <div id="PrintElementOptionSetting"></div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
import { hiprint, defaultElementTypeProvider, disAutoConnect } from 'vue-plugin-hiprint';

export default {
  name: 'yi_print_template',
  components: {},
  data() {
    return {
      hiprintTemplate: null,
      curPaper: {
        type: 'A4',
        width: 210,
        height: 296.6
      },
      paperTypes: {
        A3: {
          width: 420,
          height: 296.6
        },
        A4: {
          width: 210,
          height: 296.6
        },
        A5: {
          width: 210,
          height: 147.6
        },
        B3: {
          width: 500,
          height: 352.6
        },
        B4: {
          width: 250,
          height: 352.6
        },
        B5: {
          width: 250,
          height: 175.6
        }
      },
      // 自定义纸张
      paperPopVisible: false,
      paperWidth: '220',
      paperHeight: '80',
      // 缩放
      scaleValue: 1,
      scaleMax: 5,
      scaleMin: 0.5
    };
  },
  props: {
    jsonStr: {
      type: String,
      default: () => {
        return '{}';
      }
    },
    printData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    curPaperType() {
      let type = 'other';
      let types = this.paperTypes;
      for (const key in types) {
        let item = types[key];
        let { width, height } = this.curPaper;
        if (item.width === width && item.height === height) {
          type = key;
        }
      }
      return type;
    }
  },
  created() {
    // 初始化 provider
    disAutoConnect()
    hiprint.init({
      providers: [defaultElementTypeProvider()]
    });

    //回设纸张
    // let tmplate = JSON.parse(this.jsonStr);
    // if (tmplate.height) {
    //   this.curPaper.height = tmplate.height;
    //   this.curPaper.width = tmplate.width;
    // }
  },
  destroyed() { },
  mounted() {
    this.buildLeftElement();
    this.buildDesigner();
    this.updateJson();
  },
  methods: {
    /**
     * 构建左侧可拖拽元素
     * 注意: 可拖拽元素必须在 hiprint.init() 之后调用
     * 而且 必须包含 class="ep-draggable-item" 否则无法拖拽进设计器
     */
    buildLeftElement() {
      // eslint-disable-next-line no-undef
      hiprint.PrintElementTypeManager.buildByHtml($('.ep-draggable-item'));
    },
    /**
     * 构建设计器
     * 注意: 必须要在 onMounted 中去构建
     * 因为都是把元素挂载到对应容器中, 必须要先找到该容器
     */
    buildDesigner() {
      // eslint-disable-next-line no-undef
      $('#hiprint-printTemplate').empty(); // 先清空, 避免重复构建
      this.hiprintTemplate = new hiprint.PrintTemplate({
        settingContainer: '#PrintElementOptionSetting', // 元素参数容器
        history: true, // 是否需要 撤销重做功能
        onDataChanged: (type, json) => {
          // 模板发生改变回调
          console.log(type); // 新增、移动、删除、修改(参数调整)、大小、旋转
          console.log(json); // 返回 template
        }
      });
      // 构建 并填充到 容器中
      // 可以先 console.log($("#hiprint-printTemplate")) 看看是否有该 dom
      this.hiprintTemplate.design('#hiprint-printTemplate');
    },
    updateJson() {
      if (this.hiprintTemplate) {
        try {
          this.hiprintTemplate.update(JSON.parse(this.jsonStr));

          //回设纸张
          let tmplate = JSON.parse(this.jsonStr);
          console.log(tmplate)
          if (tmplate && tmplate.panels[0].width) {
            this.paperHeight = tmplate.panels[0].height;
            this.paperWidth = tmplate.panels[0].width;
            this.curPaper.width = tmplate.panels[0].width;
            this.curPaper.height = tmplate.panels[0].height;
            this.setPaper(this.curPaperType, this.curPaper)
            this.hiprintTemplate.setPaper(this.curPaper.width, this.curPaper.height);

          }


        } catch (e) {
          this.utils.errorMessasge('显示模板失败' + e);
        }
      }
    },

    save() {
      if (this.hiprintTemplate) {
        let jsonOut = JSON.stringify(this.hiprintTemplate.getJson() || {});
        this.$emit('update:jsonStr', jsonOut);
        console.log(jsonOut);
      }
    },

    setPaper(type, value) {
      try {
        if (Object.keys(this.paperTypes).includes(type)) {
          this.curPaper = { type: type, width: value.width, height: value.height };
          this.hiprintTemplate.setPaper(value.width, value.height);
        } else {
          this.curPaper = { type: 'other', width: value.width, height: value.height };
          this.hiprintTemplate.setPaper(value.width, value.height);
        }
      } catch (error) {
        this.utils.errorMessage(error);
      }
    },
    otherPaper() {
      let value = {};
      value.width = this.paperWidth;
      value.height = this.paperHeight;
      this.paperPopVisible = false;
      this.setPaper('other', value);
    },
    changeScale(big) {
      let scaleValue = this.scaleValue;
      if (big) {
        scaleValue += 0.1;
        if (scaleValue > this.scaleMax) scaleValue = 5;
      } else {
        scaleValue -= 0.1;
        if (scaleValue < this.scaleMin) scaleValue = 0.5;
      }
      if (this.hiprintTemplate) {
        // scaleValue: 放大缩小值, false: 不保存(不传也一样), 如果传 true, 打印时也会放大
        this.hiprintTemplate.zoom(scaleValue);
        this.scaleValue = scaleValue;
      }
    },
    /**
     * 浏览器打印
     */
    // print() {
    //   // 打印数据，key 对应 元素的 字段名
    //   let printData = { name: 'CcSimple' };
    //   // 参数: 打印时设置 左偏移量，上偏移量
    //   let options = { leftOffset: -1, topOffset: -1 };
    //   // 扩展
    //   let ext = {
    //     callback: () => {
    //       console.log('浏览器打印窗口已打开');
    //     },
    //     styleHandler: () => {
    //       // 重写 文本 打印样式
    //       return '<style>.hiprint-printElement-text{color:red !important;}</style>';
    //     }
    //   };
    //   // 调用浏览器打印
    //   this.hiprintTemplate.print(printData, options, ext);
    // },
    /**
     * 直接打印: 借助客户端,静默打印(无弹窗直接打印)
     * 注意: 需要先连接客户端
     */
    // print2() {
    //   if (hiprint.hiwebSocket.opened) {
    //     this.hiprintTemplate.print2({});
    //   } else {
    //     alert('请先连接客户端(刷新网页), 然后再点击「直接打印」');
    //   }
    // },

    /**
     * 调整元素的对齐方式
     *
     * 本函数用于通过传递对齐方式参数来调整模板中的元素对齐方式。
     * 它是组件与内部打印模板引擎之间通信的桥梁，允许外部通过调用此函数来影响模板的布局。
     *
     * @param {Object} e - 对齐参数对象，包含对齐方式的具体信息。
     */
    setElsAlign(e) {
      this.hiprintTemplate.setElsAlign(e);
    },

    exportPdf(type) {
      let printData = this.printData;
      printData.aaa = '测试';

      this.hiprintTemplate.toPdf(printData, '测试导出pdf', { isDownload: false, type: type }).then(res => {
        if (type == '') {
          const formData = new FormData();
          formData.append('file', res);

          this.http
            .post('http://127.0.0.1:8080/printLocalPDF', formData, {
              headers: {
                'Content-Type': 'multipart/form-data' // 设置请求头，确保服务器正确解析 FormData
              }
            })
            .then(res => {
              console.log(res);
            });
        }
      });
    }
  }
};
</script>
